export interface RollApplication {
	Id: number | null;
	Name: string;
	RollMaterialId: number | null;
	RollMaterialName: string | null;
	MaximumHardness: number | null;
	MinimumHardness: number | null;
	ApplicationComments: string | null;
	C: number | null;
	Mn: number | null;
	P: number | null;
	S: number | null;
	Si: number | null;
	Cr: number | null;
	Ni: number | null;
	Mo: number | null;
	Mg: number | null;
	Co: number | null;
	Va: number | null;
	W: number | null;
	Al: number | null;
	V: number | null;
	Cu: number | null;
	Active: boolean;
}

export const ROLL_APPLICATION_INITIAL_VALUES: RollApplication = {
	Id: null,
	Name: "",
	RollMaterialId: null,
	RollMaterialName: null,
	MaximumHardness: null,
	MinimumHardness: null,
	ApplicationComments: null,
	C: null,
	Mn: null,
	P: null,
	S: null,
	Si: null,
	Cr: null,
	Ni: null,
	Mo: null,
	Mg: null,
	Co: null,
	Va: null,
	W: null,
	Al: null,
	V: null,
	Cu: null,
	Active: true,
};

export interface RollMaterial {
	Id: number;
	Name: string;
}

export const CHEMICAL_FIELDS = [
	"C",
	"Mn",
	"P",
	"S",
	"Si",
	"Cr",
	"Ni",
	"Mo",
	"Mg",
	"Co",
	"Va",
	"W",
	"Al",
	"V",
	"Cu",
] as const;

export type ChemicalField = (typeof CHEMICAL_FIELDS)[number];
